export function Unmatched() {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="8" cy="8" r="7.5" fill="#ED544D" stroke="#ED544D" />
			<path
				fillRule="evenodd"
				clip-rule="evenodd"
				d="M9.889 4.951a.75.75 0 1 1 1.062 1.06L9.009 7.957l1.943 1.947a.75.75 0 0 1-1.062 1.06L7.95 9.018l-1.941 1.944a.75.75 0 1 1-1.062-1.06L6.89 7.958 4.948 6.01A.75.75 0 1 1 6.01 4.95l1.94 1.944L9.888 4.95z"
				fill="#fff"
			/>
		</svg>
	);
}
